import { makeActionCreator } from '../../../utilities'
import { ConfigurationsConstants } from './configurations.constants'

export const setServiceConfig = makeActionCreator(ConfigurationsConstants.SET_SERVICE_CONFIG, 'serviceConfig')
export const setServicesBillingConfig = makeActionCreator(
  ConfigurationsConstants.SET_SERVICES_BILLING_CONFIG,
  'servicesBillingConfig'
)
export const setTimeZone = makeActionCreator(ConfigurationsConstants.SET_TIME_ZONE, 'timeZone')
export const setCadImportConfig = makeActionCreator(ConfigurationsConstants.SET_CAD_IMPORT_CONFIG, 'cadImportConfig')
export const setEkgImportConfig = makeActionCreator(ConfigurationsConstants.SET_EKG_IMPORT_CONFIG, 'ekgImportConfig')
export const setCommandFacilityConfig = makeActionCreator(
  ConfigurationsConstants.SET_COMMAND_FACILITY_CONFIG,
  'commandFacilityConfig'
)
export const setCommandFacilityChartDeafults = makeActionCreator(
  ConfigurationsConstants.SET_COMMAND_FACILITY_CHART_DEFAULTS,
  'cmdFacChartDefaults'
)
export const setCommandFacilityProcedureDefaultAction = makeActionCreator(
  ConfigurationsConstants.SET_COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTION,
  'cmdFacProcedureDefaultAction'
)
export const setAgencyNumberConfig = makeActionCreator(
  ConfigurationsConstants.SET_AGENCY_NUMBER_CONFIG,
  'agencyNumberConfig'
)
export const setAgencyNumber = makeActionCreator(ConfigurationsConstants.SET_AGENCY_NUMBER, 'agencyNumber', 'dataset')
export const saveAgencyNumber = makeActionCreator(ConfigurationsConstants.SAVE_AGENCY_NUMBER)
export const setDatasetDeterminationConfig = makeActionCreator(
  ConfigurationsConstants.SET_DATASET_DETERMINATION_CONFIG,
  'datasetDeterminationConfig'
)
export const setTexasExportConfig = makeActionCreator(
  ConfigurationsConstants.SET_TEXAS_EXPORT_CONFIG,
  'texasExportConfig'
)
export const setTexasWristbandReportTypeConfig = makeActionCreator(
  ConfigurationsConstants.SET_TEXAS_WRISTBAND_REPORT_TYPE_CONFIG,
  'texasWristbandReportTypeConfig'
)
export const setInitialExportDatasets = makeActionCreator(ConfigurationsConstants.SET_INITIAL_EXPORT_DATASETS)

export const setDatapointsConfig = makeActionCreator(ConfigurationsConstants.SET_DATA_POINTS_CONFIG, 'datapointsConfig')
export const setIsServiceConfigLoading = makeActionCreator(
  ConfigurationsConstants.SET_IS_SERVICE_CONFIG_LOADING,
  'isServiceConfigLoading'
)
export const setAppSettingsEntries = makeActionCreator(
  ConfigurationsConstants.SET_APP_SETTINGS_ENTRIES,
  'appSettingsEntries'
)
export const resetConfig = makeActionCreator(ConfigurationsConstants.RESET_CONFIG)
